import React from "react";
import { useSkin } from "../../skins/SkinContext";
import { SkRect } from "../../prim";
import { skCat, skDog, skBird } from "../../actors3/animals";
import type { SkinSceneProps } from "./SkinParkScene";

/*
 * Anivaze v3 — a skin-aware COUNTING lesson built from animal actors. Animals pop
 * in one at a time and a big number counts 1→5, looping. Re-skins with the picker
 * (Studio / Hand-drawn / Flat / Doodle).
 */
const ANIMALS = [skCat, skDog, skCat, skBird, skDog];

export const SkinCountingScene: React.FC<SkinSceneProps> = ({ opacity = 1, t = 0, label = "Let's count the animals!" }) => {
  const skin = useSkin();
  const ground = 350;
  const cycle = t % 7; // count up over 6s, brief hold, loop
  const count = Math.min(5, Math.floor(cycle / 1.2) + 1);
  return (
    <g opacity={opacity}>
      <rect width={800} height={450} fill={skin.surface} />
      <SkRect x={0} y={ground} w={800} h={450 - ground} fill="#bbf7d0" seed={951} />

      {ANIMALS.map((fn, i) => {
        const appeared = i < count;
        const grow = appeared ? Math.min(1, (cycle - i * 1.2) / 0.35) : 0;
        if (grow <= 0) return null;
        const x = 150 + i * 125;
        return <g key={i}>{fn(x, ground, t, 0.85 * grow)}</g>;
      })}

      {/* big counter */}
      <g transform="translate(400 130)">
        <circle r={46} fill="rgba(255,255,255,0.9)" stroke="#cbd5e1" strokeWidth={2} />
        <text x={0} y={20} textAnchor="middle" fill={skin.textInk} fontSize={56} fontWeight={800} fontFamily={skin.fontFamily}>{count}</text>
      </g>

      <g transform="translate(400 44)">
        <rect x={-210} y={-22} width={420} height={40} rx={20} fill="rgba(255,255,255,0.86)" stroke="#cbd5e1" strokeWidth={1.5} />
        <text x={0} y={4} textAnchor="middle" fill={skin.textInk} fontSize={16} fontWeight={700} fontFamily={skin.fontFamily}>{label}</text>
      </g>
    </g>
  );
};
